export const accessDeniedStyles = () => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100vh - 170px)',
  };
};
